import { Target, TrendingUp, Code, Briefcase } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

export default function SkillsPage() {
  const skills = [
    {
      name: 'Artificial Intelligence & Machine Learning',
      description: 'Master AI/ML algorithms, neural networks, and deep learning to build intelligent systems.',
      salary: '$120k - $180k',
      demand: 'Very High',
      icon: Target
    },
    {
      name: 'Cloud Architecture (AWS, Azure, GCP)',
      description: 'Design and manage scalable cloud infrastructure for modern applications.',
      salary: '$130k - $190k',
      demand: 'Very High',
      icon: Code
    },
    {
      name: 'Data Science & Analytics',
      description: 'Extract insights from data using Python, R, SQL, and advanced statistical methods.',
      salary: '$110k - $160k',
      demand: 'High',
      icon: TrendingUp
    },
    {
      name: 'Cybersecurity',
      description: 'Protect systems and data from security threats and cyber attacks.',
      salary: '$100k - $150k',
      demand: 'Very High',
      icon: Briefcase
    },
    {
      name: 'Full-Stack Development',
      description: 'Build complete web applications using modern frameworks and technologies.',
      salary: '$90k - $140k',
      demand: 'High',
      icon: Code
    },
    {
      name: 'Product Management',
      description: 'Lead product strategy, development, and launch for successful products.',
      salary: '$110k - $170k',
      demand: 'High',
      icon: Briefcase
    },
    {
      name: 'Digital Marketing & SEO',
      description: 'Drive business growth through digital channels and search optimization.',
      salary: '$70k - $120k',
      demand: 'Medium',
      icon: TrendingUp
    },
    {
      name: 'Blockchain Development',
      description: 'Build decentralized applications and smart contracts on blockchain platforms.',
      salary: '$100k - $160k',
      demand: 'High',
      icon: Code
    }
  ];

  return (
    <div className="py-12 bg-white">
      <div className="container mx-auto px-4 md:px-8 lg:px-12">
        <div className="max-w-3xl mb-12">
          <h1 className="text-4xl md:text-5xl font-playfair font-bold text-foreground mb-4">High-Income Skills & Certifications</h1>
          <p className="text-lg text-muted-foreground">
            Master these in-demand skills to boost your career and earning potential in 2026. Each skill comes with high market demand and competitive salaries.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
          {skills.map((skill, idx) => {
            const Icon = skill.icon;
            return (
              <article key={idx} className="border border-border/40 bg-card shadow-sm hover:shadow-md transition-all rounded-sm p-6" data-testid={`skill-card-${idx}`}>
                <div className="flex items-start gap-4 mb-4">
                  <div className="p-3 bg-accent/10 rounded-sm">
                    <Icon size={24} className="text-accent" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-playfair font-bold text-foreground mb-2">{skill.name}</h3>
                    <p className="text-sm text-muted-foreground leading-relaxed mb-3">{skill.description}</p>
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-3">
                  <div className="border border-border/40 rounded-sm p-3">
                    <div className="text-xs text-muted-foreground mb-1">Avg. Salary</div>
                    <div className="text-sm font-bold text-foreground">{skill.salary}</div>
                  </div>
                  <div className="border border-border/40 rounded-sm p-3">
                    <div className="text-xs text-muted-foreground mb-1">Demand</div>
                    <div className="text-sm font-bold text-accent">{skill.demand}</div>
                  </div>
                </div>
              </article>
            );
          })}
        </div>

        <div className="bg-secondary rounded-sm p-8 text-center">
          <h2 className="text-2xl md:text-3xl font-playfair font-bold text-foreground mb-4">
            Ready to Upskill?
          </h2>
          <p className="text-muted-foreground mb-6 max-w-2xl mx-auto">
            Explore our curated courses and certifications to master these high-demand skills.
          </p>
          <Link to="/courses">
            <Button size="lg" className="rounded-sm" data-testid="browse-courses-btn">
              Browse Courses
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}